import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home')
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home')
  }
];

const router = new VueRouter({
  routes
});

export default router;
